import { useState, createContext, useEffect } from 'react';
import { breakpoints } from '../constants/breakpoints';

export const NavContext = createContext(null);

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ children }) => {
  const [isNavVisible, setNavVisible] = useState(false);

  useEffect(() => {
    const onResize = () => setNavVisible(window.innerWidth >= breakpoints.desktop);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <NavContext.Provider value={[isNavVisible, setNavVisible]}>{children}</NavContext.Provider>
  );
};
